import VegaContingency from "@/services/VegaContingency";

async function getStatusContingecy() {
  var vegaContingency = new VegaContingency();

  return await vegaContingency
    .getContingecyStatus()
    .then((response) => {
      return response.status;
    })
    .catch((error) => {
      return false;
    });
}

export default getStatusContingecy;
